import React from "react";
import { MapPinIcon } from '@heroicons/react/24/outline'
import "./styles.scss"
function MapButton({change}) {
  return (
    <div className='tw-z-[100] tw-fixed tw-right-[40px] tw-bottom-[30px]'>
      <div className='tw-cursor-pointer tw-map-button-bg tw-rounded tw-w-[28px] tw-h-[28px] tw-p-4 tw-relative  hover:tw-bg-white hover:tw-opacity-50 tw-max-w-xs tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-110' onClick={() => change()}>
        <MapPinIcon className="tw-h-6 tw-w-6 tw-text-primary tw-absolute tw-left-[13%] tw-top-[11%]" />
      </div>
    </div>
  )
}
export default MapButton